import { render, staticRenderFns } from "./AdminArticles.vue?vue&type=template&id=6462fd55&scoped=true&"
import script from "./AdminArticles.vue?vue&type=script&lang=js&"
export * from "./AdminArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6462fd55",
  null
  
)

export default component.exports